export const CACHE_AND_SERVICES = 'WITH_CACHE';
export const CACHE = 'CACHE_ONLY';
